import { astro } from 'iztro';
import { AstrolabeData, BirthDetails, Gender, Palace, Star } from '../types';

export const generateAstrolabe = (details: BirthDetails): AstrolabeData => {
  const [year, month, day] = details.date.split('-').map(Number);
  const [hour, minute] = details.time.split(':').map(Number);

  // iztro expects the Chinese hour index (0-12), not the solar hour (0-23)
  // 0=Zi (Early), 1=Chou, ..., 11=Hai, 12=Zi (Late)
  const chineseHourIndex = Math.floor((hour + 1) / 2);

  const horoscope = astro.bySolar(
    `${year}-${month}-${day}`,
    chineseHourIndex,
    details.gender === Gender.MALE ? '男' : '女',
    true // fixLeap
  );

  const formatStars = (stars: any[], type: Star['type']): Star[] => {
    return stars.map((s: any) => ({
      name: s.name,
      brightness: s.brightness,
      type,
    }));
  };

  const palaces: Palace[] = horoscope.palaces.map((p: any, index: number) => ({
    index,
    name: p.name,
    earthlyBranch: p.earthlyBranch,
    heavenlyStem: p.heavenlyStem,
    majorStars: formatStars(p.majorStars, 'major'),
    minorStars: formatStars(p.minorStars, 'minor'),
    adjectiveStars: formatStars(p.adjectiveStars, 'other'),
  }));

  return {
    solarDate: horoscope.solarDate,
    lunarDate: horoscope.lunarDate,
    chineseDate: horoscope.chineseDate,
    fiveElementsClass: horoscope.fiveElementsClass,
    palaces,
  };
};

export const formatAstrolabeForAI = (data: AstrolabeData): string => {
  let output = `命主紫微斗數命盤摘要:\n`;
  output += `農曆: ${data.chineseDate}, 五行局: ${data.fiveElementsClass}\n\n`;

  // Focus on the "Three Parties and Four Areas" (San Fang Si Zheng) relative to Life Palace for basic interpretation
  // But providing all 12 palaces allows for a holistic view.

  data.palaces.forEach((p) => {
    const major = p.majorStars.map(s => `${s.name}(${s.brightness})`).join(', ');
    const minor = p.minorStars.map(s => s.name).join(', ');
    output += `[${p.name} - ${p.heavenlyStem}${p.earthlyBranch}]:\n`;
    if (major) output += `  主星: ${major}\n`;
    if (minor) output += `  輔星: ${minor}\n`;
    output += '\n';
  });

  return output;
};